import styled, { css } from "styled-components"
import Link from "../shared/link"
import SmartLink from "../shared/smart-link"
import { T } from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import { FadeIn } from "../shared/keyframes.style"
import Img from "gatsby-image"

export const Orange = styled.span`
  color: var(--burnt-orange);
  font-weight: 500;
`

export const CMSFunctionsWrapper = styled.div`
  padding-bottom: 64px;
  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 128px 0;
  }
`
export const InfoWrapper = styled.div`
  ${T.sm.body.regular}
  grid-column: 1 / -1;
  margin-top: 32px;
  display: flex;
  flex-direction: column;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
    margin-top: 48px;
    align-items: center;
    grid-column: 2 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
    margin-top: 0;
    align-items: flex-start;
  }

  & > * {
    animation: ${props => !props.disableAnimations && FadeIn};
    animation-play-state: ${props => (props.isVisible ? "running" : "paused")};

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0s;
    animation-fill-mode: both;
  }

  & > * :not(:first-child) {
    animation-delay: 0.6s;
  }
`
export const SectionBody = styled.p`
  margin-top: 24px;
  color: var(--body-text-grey);
  @media (min-width: ${Breakpoints.md}) {
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
  }
`

export const List = styled.ul`
  color: var(--slate);
  list-style-type: none;
  margin-top: 32px;

  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-self: center;
  text-align: left;

  @media (min-width: ${Breakpoints.lg}) {
    justify-self: left;
    font-size: 16px;
    line-height: 130%;
    width: 100%;
    grid-column-end: -1;
  }

  & > li {
    display: inline-flex;
    align-items: flex-start;
    text-align: left;

    ::before {
      margin-right: 24px;
      height: 100%;
      content: "•";
      font-size: 20px;
      color: var(--burnt-orange);
      float: left;
    }

    :not(:last-child) {
      margin-bottom: 16px;
    }
  }
`
export const VideoContainer = styled.div`
  grid-column: 1 / -1;
  width: 100vw;
  justify-self: center;
  height: calc(100vw * 0.56);
  & > * {
    max-width: 100% !important;
    width: 100% !important;
    max-height: 100% !important;
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
    width: 100%;
    height: calc(59vw * 0.56);
  }
  @media (min-width: ${Breakpoints.md}) {
    height: calc(45vw * 0.56);
    max-height: 365px;
  }
`

export const ImageContainer = styled.div`
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }
`

export const AnimatedImage = styled(Img)`
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }
  animation: ${props => !props.disableAnimations && FadeIn};
  animation-play-state: ${props => (props.isVisible ? "running" : "paused")};

  animation-duration: 1s;
  animation-timing-function: ease;
  animation-delay: 0.5s;
  animation-fill-mode: both;
`

export const ContactUsButton = styled.div``
export const DetailsWrapper = styled.div``
export const Spacer = styled.div`
  grid-column: 1 / -1;
  margin: 64px 0 0;
  @media (min-width: ${Breakpoints.md}) {
    margin: 96px 0 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin: 192px 0 0;
  }
`

export const video1Style = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -1;
  }
`
export const video2Style = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
  }
`

export const image3Style = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -2;
  }
`

export const content1Style = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    grid-row: 1;
  }
`
export const content2Style = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -6 / -1;

    & > *:not(:first-child) {
      max-width: 80%;
    }
  }
`

export const content3Style = css`
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    grid-row: 5;
  }
`

export const StyledLink = styled(Link)`
  margin-top: 48px;
`

export const HiddenLink = styled(SmartLink)`
  text-decoration: inherit;
  color: inherit;
`
